import { Injectable } from '@angular/core';
import {
  StaffPermission,
  StaffRole,
  hasStaffPermission,
  isAdministrator as isAdministratorRole,
  isManagerOrAbove as isManagerOrAboveRole,
  normalizeStaffRole,
} from '../constants/staff-roles';
import { getStaffInfo, getStorageItem } from '../../shared/utils/storage-utils';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  getUserRole(): StaffRole {
    const tokenExchange = getStorageItem<{ role?: string } | null>('tokenExchangeResponse', null);
    if (tokenExchange?.role) {
      return normalizeStaffRole(tokenExchange.role);
    }

    const staffInfo = getStaffInfo();
    return normalizeStaffRole(staffInfo?.role);
  }

  hasPermission(permission: StaffPermission): boolean {
    return hasStaffPermission(this.getUserRole(), permission);
  }

  isAdministrator(): boolean {
    return isAdministratorRole(this.getUserRole());
  }

  isManagerOrAbove(): boolean {
    return isManagerOrAboveRole(this.getUserRole());
  }
}
